import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/TechnicianMaster.css";
import Table from "../Homepage/Table";
import AddTechnicianMaster from "./AddTechnicianMaster";
import SearchTechnicianMaster from "./SearchTechnicianMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function TechnicianMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const [loading, setloading] = useState(false);
  const tablehead = [
    "Id",
    "Name",
    "Username",
    "Company Phone No.",
    "Age",
    "Qualification",
    "Experience",
    "Years With Ross",
    "CTC",
    "Posting Location",
    "Aadhar",
    "Pan",
    "Residential Address",
    "Personal Phone No.",
  ];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [technicianupdatedata, settechnicianupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [filterbutton, setfilterbutton] = useState(false);
  const [activatedfilters, setactivatedfilters] = useState([]);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const formRef = useRef();
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [technicianId, setTechnicianId] = useState(null);

  function setsearchedtabledata(tabledata) {
    setTableData(
      tabledata.map((x) => [
        x.id,
        x.name,
        x.username,
        x.companyPhoneNumber,
        x.age,
        x.qualification,
        x.experience,
        x.yearsWithRoss,
        x.ctc,
        x.postingLocation,
        x.aadhar,
        x.pan,
        x.residentialAddress,
        x.personalPhoneNumber,
      ])
    );
  }

  function fetchtechniciandata(technicianid) {
    settechnicianupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Technician/GetTechnicianByIdOrName?id=${technicianid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        settechnicianupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Technician/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: technicianId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.name,
            x.username,
            x.companyPhoneNumber,
            x.age,
            x.qualification,
            x.experience,
            x.yearsWithRoss,
            x.ctc,
            x.postingLocation,
            x.aadhar,
            x.pan,
            x.residentialAddress,
            x.personalPhoneNumber,
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Technician" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Technician" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Technician" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Technician" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="technician-master">
      <h1>Technician Master</h1>
      <blockquote className="technician-master-forms">
        <AddMaster
          text="Add Technician Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Technician Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddTechnicianMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          technicianupdatedata={technicianupdatedata}
          key={`${technicianupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchTechnicianMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setTechnicianId={setTechnicianId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchtechniciandata}
        url="Technician/UpdateTechnician"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default TechnicianMaster;
